import React from 'react';

const SVGDownload = props => {
  return (
    <div className="svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 24">
        <title>Download</title>
        <path d="M25.5,24H.5a.5.5,0,0,1,0-1h25a.5.5,0,0,1,0,1ZM13.1,17.9a.54.54,0,0,1-.35-.14l-6.6-6.3a.5.5,0,1,1,.7-.72l5.65,5.4V.8a.5.5,0,0,1,1,0V16.33l5.85-5.59a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71l-6.6,6.3A.54.54,0,0,1,13.1,17.9Z" />
      </svg>
    </div>
  );
};

export default SVGDownload;



// WEBPACK FOOTER //
// ./src/svg/Download.js